import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'BidWorksheet' })
export class BidWorksheet {
  @Key id?: string;
  bid: string;
  version: number;
  total: number;
  fileName: string;
  fileExists: boolean;
  jobDocument: string;
  createdBy: string;
  createdByName: string;
  created: string;
  uploadUrl?: string;
}
